import { Link as MuiLink, Paper, PaperProps, Stack } from '@mui/material';

type Props = {
  navLinks: {
    href: string;
    label: string;
  }[];
} & PaperProps;

export const Navigator = ({ navLinks, sx, ...rest }: Props) => {
  return (
    <Paper sx={{ p: 2, ...sx }} {...rest}>
      <Stack direction={'column'}>
        {navLinks.map((navLink, i) => (
          <MuiLink key={i} href={navLink.href} sx={{ py: 1 }}>
            {navLink.label}
          </MuiLink>
        ))}
      </Stack>
    </Paper>
  );
};
